import React from 'react';

import { Typography } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import EmptyState from 'common/components/EmptyState';

import EmptyLayout from 'resources/EmptyLayout.svg';

import CFEGroupsList from './CFEGroupsList';

const GridArea = ({ initialValues, isEditionMode }) => {
    const { t } = useTranslation();

    if (isEmpty(initialValues)) {
        return (
            <EmptyState
                customCaption={
                    <Typography fontWeight="bold" variant="body2">
                        {t('Select a segment to start')}
                    </Typography>
                }
                onClick={() => {}}
                sizeImage={160}
                srcImage={EmptyLayout}
                sxCard={{ boxShadow: 'none !important' }}
            />
        );
    }

    return (
        <CFEGroupsList
            key={initialValues.id}
            initialValues={initialValues}
            isEditionMode={isEditionMode}
        />
    );
};

GridArea.propTypes = {
    initialValues: PropTypes.object,
    isEditionMode: PropTypes.bool,
};

export default GridArea;
